module.exports = __webpack_public_path__ + "static/media/posicao_amamentar2.2eaea717.jpg";